import { defineStore } from "pinia";
import { ref } from "vue";

export const BaseStore = defineStore('BaseStore', () => {
/***********************************************************************************************************/
/*                                              R E F                                                      */
/***********************************************************************************************************/
    const isLoading = ref<boolean>(false);

/***********************************************************************************************************/
/*                                             S T A T E                                                   */
/***********************************************************************************************************/


/***********************************************************************************************************/
/*                                            A C T I O N                                                  */
/***********************************************************************************************************/


/***********************************************************************************************************/
/*                                            G E T T E R                                                  */
/***********************************************************************************************************/


/***********************************************************************************************************/
/*                                            R E T U R N                                                  */
/***********************************************************************************************************/
    return { isLoading }

})